module.exports = __webpack_public_path__ + "static/media/bearings2.0e131bbd.png";